module.exports = __webpack_public_path__ + "static/media/Group 418@2x.3547e560.png";